import ConditionalIF from '../ConditionalIF/ConditionalIF'

const AdvanceErrorCondition = ({ node, tab }) => {
    return (
        tab === 1 ? <ConditionalIF source={"errorHandler"} tab={tab} /> : null
    )
}

export default AdvanceErrorCondition;
